import {fetchWithAuth} from '../util/fetch';
import {EndpointURL} from '../constants';
import {push} from 'react-router-redux';
import {actionFactory} from '../util/redux-helpers';

export const ACTIONS = {
  WebsitesLoading: 'WEBSITES_LOADING',
  WebsitesCompleted: 'WEBSITES_LOADED',
  WebsitesError: 'WEBSITES_ERROR',
  WebsiteDetailsLoading: 'WEBSITE_DETAILS_LOADING',
  WebsiteDetailsCompleted: 'WEBSITE_DETAILS_LOADED',
  WebsiteDetailsError: 'WEBSITE_DETAILS_ERROR',
  WebsiteMenuUpdateInProgress: 'WEBSITE_MENU_UPDATE_IN_PROGRESS',
  WebsiteMenuUpdateError: 'WEBSITE_MENU_UPDATE_ERROR',
  WebsiteMenuUpdateCompleted: 'WEBSITE_MENU_UPDATE_COMPLETED',
  WebsiteContentUpdateInProgress : 'WEBSITE_CONTENT_UPDATE_IN_PROGRESS',
  WebsiteContentUpdateError: 'WEBSITE_CONTENT_UPDATE_ERROR',
  WebsiteContentUpdateCompleted: 'WEBSITE_CONTENT_UPDATE_COMPLETED',
  MenuAddInProgress: 'MENU_ADD_IN_PROGRESS',
  MenuAddCompleted: 'MENU_ADD_COMPLETED',
  MenuAddFailed: 'MENU_ADD_FAILED',
  MenuUpdateInProgress: 'MENU_UPDATE_IN_PROGRESS',
  MenuUpdateCompleted: 'MENU_UPDATE_COMPLETED',
  MenuUpdateFailed: 'MENU_UPDATE_FAILED',
  LoadMenuDetailsInProgress: 'LOAD_MENU_DETAILS_IN_PROGRESS',
  LoadMenuDetailsCompleted: 'LOAD_MENU_DETAILS_COMPLETED',
  LoadMenuDetailsError: 'LOAD_MENU_DETAILS_ERROR',
  LoadMenuGroupDetailsInProgress: 'LOAD_MENU_GROUP_DETAILS_IN_PROGRESS',
  LoadMenuGroupDetailsCompleted: 'LOAD_MENU_GROUP_DETAILS_COMPLETED',
  LoadMenuGroupDetailsError: 'LOAD_MENU_GROUP_DETAILS_ERROR',
  LoadMenuItemDetailsInProgress: 'LOAD_MENU_ITEM_DETAILS_IN_PROGRESS',
  LoadMenuItemDetailsCompleted: 'LOAD_MENU_ITEM_DETAILS_COMPLETED',
  LoadMenuItemDetailsError: 'LOAD_MENU_ITEM_DETAILS_ERROR'
}


export function LoadWebsitesInProgress() {
  return {type: ACTIONS.WebsitesLoading};
}

export function LoadWebsitesCompleted(websites){
  console.log(websites);
  return {type: ACTIONS.WebsitesCompleted, payload: websites};
}

export function LoadWebsitesError(error){
  return {type: ACTIONS.WebsitesError, payload: error};
}

export function LoadWebsiteDetailsInProgress() {
  return {type: ACTIONS.WebsiteDetailsLoading};
}

export function LoadWebsiteDetailsCompleted(website){
  console.log(website);
  return {type: ACTIONS.WebsiteDetailsCompleted, payload: website};
}

export function LoadWebsiteDetailsError(error){
  return {type: ACTIONS.WebsiteDetailsError, payload: error};
}

export const WebsiteContentUpdateInProgress = actionFactory(ACTIONS.WebsiteContentUpdateInProgress);
export const WebsiteContentUpdateError = actionFactory(ACTIONS.WebsiteContentUpdateError);
export const WebsiteContentUpdateCompleted = actionFactory(ACTIONS.WebsiteContentUpdateCompleted);

export function LoadWebsitesEpic(companyId) {
  return async function(dispatch) {
    dispatch(LoadWebsitesInProgress());
    let fetchResult = await fetchWithAuth(`${EndpointURL}admin/companies/${companyId}/website`, {});
    if (fetchResult.status === 200){
      let jsonBody = await fetchResult.json();
      dispatch(LoadWebsitesCompleted(jsonBody));
    } else {
      let textBody = fetchResult.text()
      dispatch(LoadWebsitesError(textBody));
    }
  }
}

export function LoadWebsiteDetailsEpic(companyId) {
    return async function(dispatch) {
      dispatch(LoadWebsiteDetailsInProgress());
      let fetchResult = await fetchWithAuth(`${EndpointURL}admin/companies/${companyId}/website`, {});
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
        dispatch(LoadWebsiteDetailsCompleted(jsonBody));
      } else {
        let textBody = fetchResult.text()
        dispatch(LoadWebsiteDetailsError(textBody));
      }
  }
}

export function WebsiteMenuUpdateInProgress() {
  return {type: ACTIONS.WebsiteMenuUpdateInProgress};
}

export function WebsiteMenuUpdateError(error){
  return {type: ACTIONS.WebsiteMenuUpdateError, payload: error};
}

export function WebsiteMenuUpdateCompleted(menu){
  return {type: ACTIONS.WebsiteMenuUpdateCompleted, payload: menu};
}

export function UpdateWebsiteMenu(websiteId, menus, menu){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(WebsiteMenuUpdateInProgress());
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/website/${websiteId}/menus/${menu.id}`,
       {
         method: 'POST',
         body: JSON.stringify({ 
           menu
         })
       });
    if (fetchResult.status === 200){
      console.log('Dispatching action: WebsiteMenuUpdateCompleted');
      let responseObj = await fetchResult.json();
      dispatch(WebsiteMenuUpdateCompleted({menu: responseObj}));
    } else {
      let textBody = fetchResult.text()
      dispatch(WebsiteMenuUpdateError(textBody));
    }
  }
}

export function SaveWebsiteContentEpic(websiteId, data){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(WebsiteContentUpdateInProgress());
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/website/${websiteId}`,
       {
         method: 'PATCH',
         body: JSON.stringify(objectToPatch(data))
       });
    if (fetchResult.status === 200){
      console.log('Dispatching action: WebsiteContentUpdateCompleted');
      let responseObj = await fetchResult.json();
      dispatch(WebsiteContentUpdateCompleted(responseObj));
    } else {
      let textBody = fetchResult.text()
      dispatch(WebsiteContentUpdateError(textBody));
    }
  }
}

function objectToPatch(data) {
  return Object.keys(data).map(k => ({
    op: 'add', 
    path: `/${k}`, 
    value: data[k]
  }));
}

const MenuAddInProgress = actionFactory(ACTIONS.MenuAddInProgress);
const MenuAddCompleted = actionFactory(ACTIONS.MenuAddCompleted);
const MenuAddFailed = actionFactory(ACTIONS.MenuAddFailed);
const MenuUpdateInProgress = actionFactory(ACTIONS.MenuUpdateInProgress);
const MenuUpdateCompleted = actionFactory(ACTIONS.MenuUpdateCompleted);
const MenuUpdateFailed = actionFactory(ACTIONS.MenuUpdateFailed);
const LoadMenuDetailsInProgress = actionFactory(ACTIONS.LoadMenuDetailsInProgress);
const LoadMenuDetailsCompleted = actionFactory(ACTIONS.LoadMenuDetailsCompleted);
const LoadMenuDetailsError = actionFactory(ACTIONS.LoadMenuDetailsError);
const LoadMenuGroupDetailsInProgress = actionFactory(ACTIONS.LoadMenuGroupDetailsInProgress);
const LoadMenuGroupDetailsCompleted = actionFactory(ACTIONS.LoadMenuGroupDetailsCompleted);
const LoadMenuGroupDetailsError = actionFactory(ACTIONS.LoadMenuGroupDetailsError);
const LoadMenuItemDetailsInProgress = actionFactory(ACTIONS.LoadMenuItemDetailsInProgress);
const LoadMenuItemDetailsCompleted = actionFactory(ACTIONS.LoadMenuItemDetailsCompleted);
const LoadMenuItemDetailsError = actionFactory(ACTIONS.LoadMenuItemDetailsError);

export function AddMenuEpic(websiteId, menuData) {
  console.log(menuData);
  return async (dispatch, getState) => {
    dispatch(MenuAddInProgress());
    menuData.menu_url = menuData.menu_name.replace(/[\W_]+/g,"-").toLowerCase();
    let fetchResult = await fetchWithAuth(`${EndpointURL}admin/website/${websiteId}/menus`,{
      method: 'POST',
      body: JSON.stringify(menuData)
    });
    if (fetchResult.status === 201) {
      let result = await fetchResult.json();
      dispatch(MenuAddCompleted(result));
      dispatch(push(`/menus`));
    } else {
      dispatch(MenuAddFailed(await fetchResult.text()));
    }
  }
}

export function LoadMenuDetailsEpic(websiteId, menuId) {
    return async function(dispatch) {
      dispatch(LoadMenuDetailsInProgress());
      let fetchResult = await fetchWithAuth(`${EndpointURL}admin/website/${websiteId}/menus/${menuId}`, {});
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
        dispatch(LoadMenuDetailsCompleted(jsonBody));
      } else {
        let textBody = fetchResult.text()
        dispatch(LoadMenuDetailsError(textBody));
      }
  }
}

export function LoadMenuGroupDetailsEpic(websiteId, menuId, groupId) {
    return async function(dispatch) {
      dispatch(LoadMenuGroupDetailsInProgress());
      let fetchResult = await fetchWithAuth(`${EndpointURL}admin/website/${websiteId}/menus/${menuId}/group/${groupId}`, {});
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
        dispatch(LoadMenuGroupDetailsCompleted(jsonBody));
      } else {
        let textBody = fetchResult.text()
        dispatch(LoadMenuGroupDetailsError(textBody));
      }
  }
}

export function LoadMenuItemDetailsEpic(websiteId, menuId, groupId, menuItemId) {
    return async function(dispatch) {
      dispatch(LoadMenuItemDetailsInProgress());
      let fetchResult = await fetchWithAuth(`${EndpointURL}admin/website/${websiteId}/menus/${menuId}/group/${groupId}/item/${menuItemId}`, {});
      if (fetchResult.status === 200){
        let jsonBody = await fetchResult.json();
        dispatch(LoadMenuItemDetailsCompleted(jsonBody));
      } else {
        let textBody = fetchResult.text()
        dispatch(LoadMenuItemDetailsError(textBody));
      }
  }
}

export function SaveMenuEpic(websiteId, menuId, data){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(MenuUpdateInProgress());
    data.menu_url = data.menu_name.replace(/[\W_]+/g,"-").toLowerCase();
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/website/${websiteId}/menus/${menuId}`,
       {
         method: 'PATCH',
         body: JSON.stringify(objectToPatch(data))
       });
    if (fetchResult.status === 200){
      console.log('Dispatching action: WebsiteContentUpdateCompleted');
      let responseObj = await fetchResult.json();
      dispatch(MenuUpdateCompleted(responseObj));
      dispatch(push(`/menus`));
    } else {
      let textBody = fetchResult.text()
      dispatch(MenuUpdateFailed(textBody));
    }
  }
}

export function SaveMenuItemEpic(websiteId, menuId, groupId, itemId, data){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(MenuUpdateInProgress());
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/website/${websiteId}/menus/${menuId}/group/${groupId}/items/${itemId}`,
       {
         method: 'PATCH',
         body: JSON.stringify(objectToPatch(data))
       });
    if (fetchResult.status === 200){
      console.log('Dispatching action: WebsiteContentUpdateCompleted');
      let responseObj = await fetchResult.json();
      dispatch(MenuUpdateCompleted(responseObj));
      dispatch(push(`/websites/${websiteId}/menu/${menuId}`));
    } else {
      let textBody = fetchResult.text()
      dispatch(MenuUpdateFailed(textBody));
    }
  }
}

export function CreateMenuItemEpic(websiteId, menuId, groupId, data){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(MenuUpdateInProgress());
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/website/${websiteId}/menus/${menuId}/group/${groupId}/items`,
       {
         method: 'POST',
         body: JSON.stringify(data)
       });
    if (fetchResult.status === 201){
      console.log('Dispatching action: WebsiteContentUpdateCompleted');
      let responseObj = await fetchResult.json();
      dispatch(MenuUpdateCompleted(responseObj));
      dispatch(push(`/websites/${websiteId}/menu/${menuId}`));
    } else {
      let textBody = fetchResult.text()
      dispatch(MenuUpdateFailed(textBody));
    }
  }
}

export function DeleteMenuItemEpic(websiteId, menuId, groupId, menuItemId, data){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(MenuUpdateInProgress());
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/website/${websiteId}/menus/${menuId}/group/${groupId}/items/${menuItemId}`,
       {
         method: 'DELETE'
       });
    if (fetchResult.status === 200){
      console.log('Dispatching action: WebsiteContentUpdateCompleted');
      let responseObj = await fetchResult.json();
      dispatch(MenuUpdateCompleted(responseObj));
      dispatch(push(`/websites/${websiteId}/menu/${menuId}`));
    } else {
      let textBody = fetchResult.text()
      dispatch(MenuUpdateFailed(textBody));
    }
  }
}

export function DeleteMenuEpic(websiteId, menuId){
  return async function(dispatch) { //redux-thunk middleware for async dispatching support
    dispatch(MenuUpdateInProgress());
    let fetchResult = await fetchWithAuth(
      `${EndpointURL}admin/website/${websiteId}/menus/${menuId}`,
       {
         method: 'DELETE'
       });
    if (fetchResult.status === 200){
      console.log('Dispatching action: WebsiteContentUpdateCompleted');
      let responseObj = await fetchResult.json();
      dispatch(MenuUpdateCompleted(responseObj));
      dispatch(push(`/menus`));
    } else {
      let textBody = fetchResult.text()
      dispatch(MenuUpdateFailed(textBody));
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/website.actions.js